import * as types from './types';

export const resetTimesheetRowsState = (data) => ({ type: types.RESET_TIMESHEET_ROWS_STATE, data });

export const createTimesheetRowRequest = (data) => ({ type: types.CREATE_TIMESHEET_ROW_REQUEST, data });
export const createTimesheetRowRequestFailure = (error) => ({ type: types.CREATE_TIMESHEET_ROW_REQUEST_FAILURE, error });
export const createTimesheetRowRequestSuccess = (data) => ({ type: types.CREATE_TIMESHEET_ROW_REQUEST_SUCCESS, data });

export const deleteTimesheetRowRequest = (data) => ({ type: types.DELETE_TIMESHEET_ROW_REQUEST, data });
export const deleteTimesheetRowRequestFailure = (error) => ({ type: types.DELETE_TIMESHEET_ROW_REQUEST_FAILURE, error });
export const deleteTimesheetRowRequestSuccess = (data) => ({ type: types.DELETE_TIMESHEET_ROW_REQUEST_SUCCESS, data });

export const getTimesheetRowRequest = (data) => ({ type: types.GET_TIMESHEET_ROWS_REQUEST, data });
export const getTimesheetRowRequestFailure = (error) => ({ type: types.GET_TIMESHEET_ROWS_REQUEST_FAILURE, error });
export const getTimesheetRowRequestSuccess = (data) => ({ type: types.GET_TIMESHEET_ROWS_REQUEST_SUCCESS, data });

export const getTimesheetRowsRequest = (data) => ({ type: types.GET_TIMESHEET_ROWS_REQUEST, data });
export const getTimesheetRowsRequestFailure = (error) => ({ type: types.GET_TIMESHEET_ROWS_REQUEST_FAILURE, error });
export const getTimesheetRowsRequestSuccess = (data) => ({ type: types.GET_TIMESHEET_ROWS_REQUEST_SUCCESS, data });

export const toggleRowBillableRequest = (data) => ({ type: types.TOGGLE_ROW_BILLABLE_REQUEST, data });
export const toggleRowBillableRequestFailure = (error) => ({ type: types.TOGGLE_ROW_BILLABLE_REQUEST_FAILURE, error });
export const toggleRowBillableRequestSuccess = (data) => ({ type: types.TOGGLE_ROW_BILLABLE_REQUEST_SUCCESS, data });

export const updateTimesheetRowRequest = (data) => ({ type: types.UPDATE_TIMESHEET_ROW_REQUEST, data });
export const updateTimesheetRowRequestFailure = (error) => ({ type: types.UPDATE_TIMESHEET_ROW_REQUEST_FAILURE, error });
export const updateTimesheetRowRequestSuccess = (data) => ({ type: types.UPDATE_TIMESHEET_ROW_REQUEST_SUCCESS, data });

export const updateTimesheetRowDimensionsRequest = (data) => ({ type: types.UPDATE_TIMESHEET_ROW_DIMENSIONS_REQUEST, data });
export const updateTimesheetRowDimensionsRequestFailure = (error) => ({
  type: types.UPDATE_TIMESHEET_ROW_DIMENSIONS_REQUEST_FAILURE,
  error,
});
export const updateTimesheetRowDimensionsRequestSuccess = (data) => ({ type: types.UPDATE_TIMESHEET_ROW_DIMENSIONS_REQUEST_SUCCESS, data });
